module.exports = __webpack_public_path__ + "static/media/main.f1d3d85b.png";